import { IRootState } from '../../../store'
import { IInsuranceInformationState } from '../store/insuranceInformation.types'

export const getInsuranceInformationStateSelector = (state: IRootState): IInsuranceInformationState =>
  state.insuranceInformation
